import { useNotificationStore } from "../context";

const useAlert = () => {
  const { setOpen, setTitle, setBody, setAutoClose, setType } =
    useNotificationStore();
  return (title, body, type, autoClose) => {
    setTitle(title);
    setBody(body);
    setOpen(true);
    setType(type);
    setAutoClose(autoClose !== undefined ? autoClose : true);
  };
};

export default useAlert;
